import {Component, OnInit, Input, ViewChild, OnDestroy} from "@angular/core";
import {PageEvent} from "@angular/material/paginator";
import {MainService} from "src/app/Services/service.service";
import {DTOAdvertisementEx} from "src/app/api/LocalModels";
import {DTOAdvertisement, Region, SubRegion, ShowAdType, AdveristmentsClient, GetAdvertisementsRequest, } from "../../api/WickedApiClient";
import {MatMenuTrigger} from "@angular/material/menu";
import {GeolocationService} from "../../Services/geolocation.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, NavigationStart, Router, NavigationEnd} from "@angular/router";
import {SearchRouteService} from "../../Services/searchroute.service";
import {environment} from "src/environments/environment";


interface IUrlSearchParams {
  casualDating: string,
  city: string,
  page: number,
  relationShip: string,
  state: string,
  withPicture: string
}

@Component({
  selector: "app-search-results",
  templateUrl: "./search-results.component.html",
  styleUrls: ["./search-results.component.css"]
})
export class SearchResultsComponent implements OnInit, OnDestroy {
  private _regionShortName: string = null;
  private _subregionName: string = null;
  private breakpoint: number = 4;
  public _loading = true;
  public enableSubscription: boolean = false;

  public get loading(): boolean {
    return this._loading;
  }
  public set loading(value: boolean) {
    this._loading = value;
  }
  public isPremium: boolean = false;

  constructor(public service: MainService, public geolocationService: GeolocationService, private searchRouteService: SearchRouteService, private advertisementClient: AdveristmentsClient, private router: Router, private route: ActivatedRoute) {

    this.enableSubscription = service.enableSubscription;

    this.isPremium = this.service.userService.isPremium();

    this.updateResultList();

    this.service.advService.resultListUpdate.subscribe(r => {
      this._cardList = this.service.advService.searchDataStandard.resultList;
      this.loading = false;
    });

    this.searchRouteService.categoryData.subscribe(data => {

      this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = data.categoryId;
      this.service.advService.searchDataStandard.currentSearchRule.casualDating = data.casualDating;
      this.service.advService.performSearchActionWithoutNavigateToSearchResult();
      //this._cardList = this.service.advService.searchDataStandard.resultList;
    });

    this.service.advService.searchInActionChanged.subscribe(s => {
      this.loading = s;
    });

  }
  updateResultList() {
    this._cardList = this.service.advService.searchDataStandard.resultList;
  }

  public get showClosestRegionMessage() {
    return this.ClosestSubregionNameIfNoResult && this.SubregionName != "" && this.RegionName != "" && this.ClosestSubregionNameIfNoResult != `${this.SubregionName}, ${this.RegionName}`
  }

  public get ClosestSubregionNameIfNoResult() {
    return this.service.advService.searchDataStandard.ClosestSubregionNameIfNoResult;
  }

  public get length() {
    return this.service.advService.searchDataStandard.resultCount;
  }

  public get pageSize() {
    return this.service.advService.searchDataStandard.currentSearchRule.pageSize;
  }

  public get pageNumber() {
    return this.service.advService.searchDataStandard.currentSearchRule.pageNumber;
  }

  public get SubregionName() {
    if(this._subregionName != null) {
      return this._subregionName;
    }
    return "";
  }

  public get RegionName() {
    if(this._regionShortName != null) {
      return this._regionShortName;
    }
    return "";
  }



  public getAdvertismentImage(advertisment: DTOAdvertisement): string {
    if(advertisment.images.length == 0) {
      return "";
    }

    let image = advertisment.images.find(image => image.isMain == true);
    if(image == null) {
      image = advertisment.images[0];
    } else {
      image = image[0];
    }
    return image.fileName;
  }

  pageSizeOptions: number[] = [4, 12, 24, 100]; // index 2 is default

  private _pageEvent: PageEvent;
  public get pageEvent(): PageEvent {
    return this._pageEvent;
  }

  public set pageEvent(value: PageEvent) {
    this.service.advService.searchDataStandard.currentSearchRule.pageNumber = value.pageIndex;
    if(this.pageSizeOptions[2] == value.pageSize) this.changeUrlPage(value.pageIndex + 1);
    else this.changeUrlPage(value.pageIndex + 1, value.pageSize);

    this.service.advService.searchDataStandard.currentSearchRule.pageSize = value.pageSize;
    this.service.advService.searchAction(false);
    this._pageEvent = value;
  }

  public changeUrlPage(toPage: number, pageSize: number = null) {
    let currentUrl = document.location.href;
    const regexPage = /(-page-[0-9]+)/;
    const regexPerPage = /(-per-[0-9]+)/;
    const foundPage = currentUrl.match(regexPage);
    const foundPer = currentUrl.match(regexPerPage);
    let nextUrl = currentUrl;
    if(foundPage) nextUrl = nextUrl.replace(regexPage, '-page-' + toPage);
    else nextUrl = nextUrl + '-page-' + toPage;
    if(pageSize) {
      if(foundPer) nextUrl = nextUrl.replace(regexPerPage, '-per-' + pageSize);
      else nextUrl = nextUrl + '-per-' + pageSize;
    }
    const nextState = {additionalInformation: 'next Page ' + toPage + 'page size ' + pageSize};
    window.history.pushState(nextState, document.title, nextUrl);
  }

  public listLayoutType = displayModeType;
  private _listLayout: displayModeType = displayModeType.LIST;
  public get listLayout(): displayModeType {
    return this._listLayout;
  }

  public set listLayout(value: displayModeType) {
    this._listLayout = value;
  }


  changeSearchSubscriber: Subscription;

  updateInterval: any;


  ngOnInit() {
    this.service.advService.searchDataStandard.SubregionNameChanged.subscribe(value => {
      this._subregionName = value;
    });

    this.service.advService.searchDataStandard.RegionShortNameChanged.subscribe(value => {
      this._regionShortName = value;
    });

    //this.triggerSearchFromUrl();

    if(window.innerWidth < 576) {
      this.breakpoint = 1;
    } else if(window.innerWidth < 992) {
      this.breakpoint = 2;
    } else if(window.innerWidth < 1200) {
      this.breakpoint = 3;
    } else {
      this.breakpoint = 4;
    }
  }

  triggerSearchFromUrl() {
    let request = new GetAdvertisementsRequest();
    request.init(this.route.snapshot.params);
    this.advertisementClient.getAdveristmentGetModel(request).toPromise().then(response => {
      this.service.advService.searchDataStandard.currentSearchRule.pageNumber = response.pageNumber;
      this.service.advService.searchDataStandard.currentSearchRule.regionId = response.regionId;
      this.service.advService.searchDataStandard.currentSearchRule.subRegionId = response.subRegionId;
      this.service.advService.searchDataStandard.currentSearchRule.casualDating = response.casualDating;
      this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = response.advertisementCategoryId;
      this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly = response.withPicturesOnly;
      this.service.advService.searchAction();
    });
  }

  ngOnDestroy() {

  }

  onResize(event) {

    if(event.target.innerWidth < 576) {
      this.breakpoint = 1;
    } else if(event.target.innerWidth < 992) {
      this.breakpoint = 2;
    } else if(event.target.innerWidth < 1200) {
      this.breakpoint = 3;
    } else {
      this.breakpoint = 4;
    }
  }

  private firstSearchPerformed: boolean = false;

  private _cardList: DTOAdvertisementEx[] = null;
  public get cardList(): DTOAdvertisementEx[] {
    return this._cardList;
  }


  public getLocation(adv: DTOAdvertisementEx) {
    return adv.subRegionName + ", " + adv.regionShortName;
  }

  public getAdvDate(adv: DTOAdvertisementEx) {
    if(adv.dateStart != null) {
      return adv.dateStart.format("MM/DD/YYYY")
    } else return "";
  }

  public getAdvTag(adv: DTOAdvertisementEx) {
    var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : `[${adv.categoryCode}] `;
    return `${tag}`;
  }

  public getAdvTitle(adv: DTOAdvertisementEx) {
    return `${adv.title}`;
  }

  public getImageFromCard(card: DTOAdvertisementEx) {
    if(card.images.length > 0) {
      let mainImage = card.images.filter(v => v.isMain == true);

      if(mainImage.length > 0) {
        return `${environment.apiBaseUrl}/FileGet/${mainImage[0].fileName}/300x700`;
      } else {
        return `${environment.apiBaseUrl}/FileGet/${card.images[0].fileName}/300x700`;
      }
    } else {
      return `${environment.apiBaseUrl}/images/placeholder.jpg`;
    }
  }

  public hasAdvertismentImage(advertisment: DTOAdvertisement): boolean {
    return advertisment.images.length > 0;
  }

  private _currentUserIsAdminUser: boolean = null;
  currentUserIsAdminUser(): boolean {
    if(this._currentUserIsAdminUser == null) {
      this._currentUserIsAdminUser = this.service.userService.isAuthenticated() && this.service.userService.isAdmin();
    }
    return this._currentUserIsAdminUser;
  }

  private _currentUserIsDemoUser: boolean = null;
  currentUserIsDemoUser(): boolean {
    if(this._currentUserIsDemoUser == null) {
      this._currentUserIsDemoUser = this.service.userService.isAuthenticated() && this.service.userService.isDemo();
    }
    return this._currentUserIsDemoUser;
  }

  openAdv(id: string) {
    this.service.route.navigate([`adv-detail/${id}`]);
  }

  getPremiumText(advertisement: DTOAdvertisementEx) {
    if(advertisement.showAs == ShowAdType.PremiumAd) {
      return "Premium Ad";
    } else if(advertisement.showAs == ShowAdType.PremiumUser) {
      return "Premium User";
    } else if(advertisement.isPremium) {
      if(advertisement.isPremiumUser) {
        return "Premium User";
      } else {
        return "Premium Ad";
      }
    }

    return "";
  }

  openImageMenu(trigger: MatMenuTrigger) {
    trigger.openMenu()
  }

  closeImageMenu(trigger: MatMenuTrigger) {
    trigger.closeMenu()
  }

  isSeen(card: DTOAdvertisementEx): boolean {
    if(!this.currentUserIsAdminUser()) {
      return true;
    }

    if(card.isDemo) {
      return true;
    }


    if(this.currentUserIsAdminUser() && card.seenAdmin) {
      return true;
    }

    if(this.currentUserIsDemoUser() && card.seen) {
      return true;
    }



    return false;
  }

  pageChange(e) {
    window.scroll(0, 0);
  }
}

export enum displayModeType {
  ROW = "_layoutROW",
  LIST = "_layoutLIST",
  TILE = "_layoutTile",
  GRID = "_layoutGrid",
}
